;
(function (ng) {
  'use strict';

  angular.module('zone', []);
})(window.angular);